<div class="super-social-c ion-padding">
  <div class="super-social-c__content">
    <img src="assets/images/logo_instituto.png" alt="Instituto UsuCampeão">

    <ion-text>
      <p class="font-text">Participante do programa Super Social</p>
    </ion-text>
  </div>

  <div class="super-social-c__tag">
    <ion-icon name="warning" mode="md"></ion-icon>
    <ion-text>
      Em análise de elegibilidade para participação
    </ion-text>
  </div>
</div>